export default __webpack_public_path__ + "static/media/Group9234.a58673d7.svg";